module.exports = __webpack_public_path__ + "img/ic_daily_attendance.a83a8267.png";